import React from "react";
import * as Styles from "./styles/ContainerStyles";
import { Container } from "@material-ui/core";
import { WinHistoryComponent } from "../win-history/WinHistoryComponent";
import { SecureArea } from "../authentication/SecureArea";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../services/TelemetryService";

const AuctionsWon: React.FC = () => {
  const classes = Styles.ContainerStyles();

  return (
    <SecureArea>
      <Container fixed className={classes.container}>
        <WinHistoryComponent />
      </Container>
    </SecureArea>
  );
};

export default withAITracking(reactPlugin, AuctionsWon, "AuctionsWon");
